<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "SuorganizatorBase"
};
</script>

<style scoped>

</style>
